@if (displayReactions) {
    <div class="emoji-icons" clickedOut (clickOutside)="closeDropdown()" #sbReaction>
        @if (reactionJourney === 1) {
            <div
                class="static_emoji"
                [ngClass]="{ 'reaction-saved': reactionSaved, 'red-border': isLadbrokes, 'blue-border': !isLadbrokes }"
                (click)="openReactions()">
                <div
                    class="single-emoji-class d-flex flex-row"
                    [ngClass]="{
                        'red-border': this.userReaction === 'REACTION1' && isLadbrokes,
                        'blue-border': this.userReaction === 'REACTION1' && !isLadbrokes,
                    }"
                    [class.selected-reaction]="this.userReaction === 'REACTION1'"
                    id="{{ surfaceBet.objId }}_REACTION1"
                    [style.order]="this.userReaction === 'REACTION1' ? '0' : '1'"
                    #sbReaction0>
                    <svg>
                        <use xlink:href="#sb_like"></use>
                    </svg>
                    @if (reactionSaved) {
                        <span class="reaction-count" [ngClass]="isLadbrokes ? 'font-helvetica' : 'font-lato'">
                            {{ this.singleReactionCount?.reaction1_globalCount | NumToThousands }}</span
                        >
                    }
                    @if (sbReaction0.style.order !== '0') {
                        <div [ngClass]="{ 'svg-reaction-border': reactionJourney === 1 }"></div>
                    }
                </div>
                <div
                    class="single-emoji-class d-flex flex-row"
                    [class.border-0]="this.userReaction === 'REACTION3'"
                    [ngClass]="{
                        'red-border': this.userReaction === 'REACTION2' && isLadbrokes,
                        'blue-border': this.userReaction === 'REACTION2' && !isLadbrokes,
                    }"
                    [class.selected-reaction]="this.userReaction === 'REACTION2'"
                    id="{{ surfaceBet.objId }}_REACTION2"
                    [style.order]="this.userReaction === 'REACTION2' ? '0' : '2'"
                    #sbReaction1>
                    <svg>
                        <use xlink:href="#sb_thinking"></use>
                    </svg>
                    @if (reactionSaved) {
                        <span class="reaction-count" [ngClass]="isLadbrokes ? 'font-helvetica' : 'font-lato'">
                            {{ this.singleReactionCount?.reaction2_globalCount | NumToThousands }}
                        </span>
                    }
                    @if (sbReaction1.style.order !== '0' && sbReaction2.style.order !== '0') {
                        <div [ngClass]="{ 'svg-reaction-border': this.userReaction !== 'REACTION3' && reactionJourney === 1 }"></div>
                    }
                </div>
                <div
                    class="single-emoji-class d-flex flex-row"
                    [ngClass]="{
                        'red-border': this.userReaction === 'REACTION3' && isLadbrokes,
                        'blue-border': this.userReaction === 'REACTION3' && !isLadbrokes,
                    }"
                    [class.selected-reaction]="this.userReaction === 'REACTION3'"
                    id="{{ surfaceBet.objId }}_REACTION3"
                    [style.order]="this.userReaction === 'REACTION3' ? '0' : '3'"
                    #sbReaction2>
                    <svg>
                        <use xlink:href="#sb_dislike"></use>
                    </svg>
                    @if (reactionSaved) {
                        <span class="reaction-count" [ngClass]="isLadbrokes ? 'font-helvetica' : 'font-lato'">
                            {{ this.singleReactionCount?.reaction3_globalCount | NumToThousands }}
                        </span>
                    }
                </div>
                @if (globalCount <= 10 && !reactionSaved) {
                    <span class="label-text" [ngClass]="isLadbrokes ? 'font-helvetica' : 'font-lato'" style="order: 4">{{
                        sbReactionConfig.firstReactText
                    }}</span>
                }
                @if (globalCount > 10 && !reactionSaved) {
                    <span class="label-text" [ngClass]="isLadbrokes ? 'font-helvetica' : 'font-lato'" style="order: 4">
                        {{ globalCount | NumToThousands }}
                    </span>
                }
            </div>
        }
        @if (reactionJourney === 2) {
            <div class="animate-reaction" [ngClass]="isLadbrokes ? 'red-border' : 'blue-border'">
                <svg class="emoji_svg" id="REACTION1" (click)="selectReaction('REACTION1', 'sb_like', surfaceBet.objId, sbReaction)">
                    <use xlink:href="#sb_like"></use>
                </svg>
                <svg class="emoji_svg" id="REACTION2" (click)="selectReaction('REACTION2', 'sb_thinking', surfaceBet.objId, sbReaction)">
                    <use xlink:href="#sb_thinking"></use>
                </svg>
                <svg class="emoji_svg" id="REACTION3" (click)="selectReaction('REACTION3', 'sb_dislike', surfaceBet.objId, sbReaction)">
                    <use xlink:href="#sb_dislike"></use>
                </svg>
            </div>
        }
        @if (reactionJourney === 3) {
            <div class="transp-bg">
                <svg class="emoji_svg_animate">
                    <use [attr.xlink:href]="'#' + svg_Id"></use>
                </svg>
            </div>
        }
    </div>
}
